<template>
  <div class="orbit-wrapper">
    <div class="ring ring-1"></div>
    <div class="ring ring-2"></div>
    <div class="orbit orbit-1"><div class="orb orb-orange"></div></div>
    <div class="orbit orbit-2"><div class="orb orb-white"></div></div>
    <div class="orbit orbit-3"><div class="orb orb-dim"></div></div>
  </div>
</template>

<script>
export default { name: 'OrbitRings' };
</script>
